module.exports = __webpack_public_path__ + "static/2012-layer-3-059228e952fd95355cf9fae313b0302e.png";